import {Component, OnInit} from '@angular/core';
import {AppConfigService} from '../../../../Services/app-config.service';
import {DataService} from '../../../../Services/data.service';
import {HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {ResponseModel} from '../../../../DataModels/response-model';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {PagerStateService} from '../../../../Services/pager-state.service';
import {NgbpaginationConfigService} from '../../../../Services/ngbpagination-config.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-bank-reconciliation-list',
  templateUrl: './bank-reconciliation-list.component.html',
  styleUrls: ['./bank-reconciliation-list.component.css'],
  standalone: false
})
export class BankReconciliationListComponent extends ListPageBase implements OnInit {
  constructor(
    private table: DataService,
    private toastr: BsToastService,
    private titleService: Title,
    private dateFilter: DateFilterService
  ) {
    super();
  }

  bankReconciliationList: Array<any>;
  bankReconciliationCount = 0;
  isLoaded = false;
  serverSearchTerm = '';
  vm: any = {};





  ngOnInit() {
    this.restorePagerState();
    this.vm.searchHidden = false;
    this.vm.list = [];
    this.titleService.setTitle($localize`:Bank Reconciliation List @@bankReconciliationList:Bank Reconciliation List`);
    // Restore pager from enhanced per-tab cache (sessionStorage + memory)
    this.getData();
  }


  getData() {
    let paramString = '';
    paramString = 'search=' + (this.vm.bankRecSearch ? this.vm.bankRecSearch : '');
    paramString +=
      '&fromDate=' + (this.vm.bankRecFromDate ? this.dateFilter.GetDateFormat(this.vm.bankRecFromDate) : '');
    paramString += '&toDate=' + (this.vm.bankRecToDate ? this.dateFilter.GetDateFormat(this.vm.bankRecToDate) : '');
    paramString += '&pageNumber=' + (this.page - 1);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('bank_reconciliation', '?' + paramString).subscribe({
      next: (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.bankReconciliationCount = result.totalRecords;
        this.isLoaded = true;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
      complete: () => {
      }
    });
  }

  onNavigate(aID: string) {
    this.router.navigate(['/transactions/bank-reconciliation/bank-reconciliation-form', {id: aID}]).then();
  }

  // Server side paging ---------------------------------------------------------------------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString = '';
    paramString = 'search=' + (this.vm.bankRecSearch ? this.vm.bankRecSearch : '');
    paramString +=
      '&fromDate=' + (this.vm.bankRecFromDate ? this.dateFilter.GetDateFormat(this.vm.bankRecFromDate) : '');
    paramString += '&toDate=' + (this.vm.bankRecToDate ? this.dateFilter.GetDateFormat(this.vm.bankRecToDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('bank_reconciliation', '?' + paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {
        // 'onCompleted' callback.
        // this.toastr.success('', 'Bank Reconciliation Data Loaded', {
        //   timeOut: 1000
        // });
      }
    );
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }

  serverSearch(value) {
    this.vm.bankRecSearch = value.searchTerm;
    this.vm.bankRecFromDate = value.fromDate;
    this.vm.bankRecToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.bankRecSearch = value.searchTerm;
    this.vm.bankRecFromDate = value.fromDate;
    this.vm.bankRecToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }
}
